import * as React from "react";
import {
  SvgIcon,
  ButtonProps as MUIButtonProps,
  styled,
  Button,
} from "@mui/material";
import { convertPxToRem } from "@treez-inc/component-library";

export interface GoogleButtonProps
  extends Pick<MUIButtonProps, "disabled" | "onClick"> {
  label: string;
  googleSSOUrl: any;
}

const StyledGoogleButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primaryWhite.main,
  border: `${convertPxToRem(1)} solid ${theme.palette.grey05.main}`,
  color: theme.palette.green10.main,
  height: convertPxToRem(40),
  padding: `0rem ${convertPxToRem(20)} 0rem ${convertPxToRem(16)}`,
  borderRadius: convertPxToRem(15),
  transition: `all 0.2s`,
  marginBottom: convertPxToRem(24),
  minWidth: "100%",
  ...theme.typography.largeTextStrong,
  "&:hover": {
    backgroundColor: theme.palette.green03.main,
    border: `${convertPxToRem(1)} solid ${theme.palette.grey07.main}`,
  },
  "&:disabled": {
    backgroundColor: theme.palette.primaryWhite.main,
    border: `${convertPxToRem(1)} solid ${theme.palette.grey04.main}`,
  },
  "&:active": {
    transform: `scale(0.98)`,
  },
  "&.Mui-focusVisible": {
    border: `${convertPxToRem(2.5)} solid ${theme.palette.primaryBlack.main}`,
  },
}));

const GoogleLogo = () => (
  <SvgIcon>
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8" clipPath="url(#clip0_2458_5721)">
        <path
          d="M19.245 8.59463L11.0872 8.59424C10.727 8.59424 10.435 8.88619 10.435 9.24643V11.8525C10.435 12.2126 10.727 12.5047 11.0872 12.5047H15.6812C15.1781 13.8102 14.2392 14.9035 13.0413 15.5982L15.0002 18.9892C18.1425 17.1719 20.0002 13.9832 20.0002 10.4138C20.0002 9.90553 19.9627 9.54221 19.8878 9.13311C19.8309 8.82229 19.561 8.59463 19.245 8.59463Z"
          fill="#167EE6"
        />
        <path
          d="M10.0002 16.4203C7.75198 16.4203 5.78932 15.192 4.73522 13.3743L1.34436 15.3287C3.06995 18.3194 6.30252 20.3334 10.0002 20.3334C11.8141 20.3334 13.5257 19.845 15.0002 18.9938V18.9892L13.0413 15.5982C12.1453 16.1179 11.1084 16.4203 10.0002 16.4203Z"
          fill="#12B347"
        />
        <path
          d="M15 18.9938V18.9892L13.0411 15.5981C12.1451 16.1178 11.1083 16.4203 10 16.4203V20.3333C11.8139 20.3333 13.5256 19.8449 15 18.9938Z"
          fill="#0F993E"
        />
        <path
          d="M3.91305 10.3334C3.91305 9.2252 4.21547 8.18844 4.73504 7.29247L1.34418 5.33801C0.488359 6.80782 0 8.51477 0 10.3334C0 12.152 0.488359 13.8589 1.34418 15.3287L4.73504 13.3743C4.21547 12.4783 3.91305 11.4415 3.91305 10.3334Z"
          fill="#FFD500"
        />
        <path
          d="M10.0002 4.24642C11.4662 4.24642 12.8129 4.76736 13.8647 5.63388C14.1242 5.84763 14.5014 5.8322 14.739 5.59451L16.5855 3.74802C16.8552 3.47833 16.836 3.03689 16.5479 2.78697C14.7856 1.2581 12.4926 0.333374 10.0002 0.333374C6.30252 0.333374 3.06995 2.34732 1.34436 5.33802L4.73522 7.29248C5.78932 5.47478 7.75198 4.24642 10.0002 4.24642Z"
          fill="#FF4B26"
        />
        <path
          d="M13.8645 5.63388C14.124 5.84763 14.5012 5.8322 14.7389 5.59451L16.5854 3.74802C16.855 3.47833 16.8358 3.03689 16.5477 2.78697C14.7854 1.25806 12.4925 0.333374 10 0.333374V4.24642C11.466 4.24642 12.8127 4.76736 13.8645 5.63388Z"
          fill="#D93F21"
        />
      </g>
      <defs>
        <clipPath id="clip0_2458_5721">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.333374)"
          />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);

const GoogleButton = ({ label, googleSSOUrl }: GoogleButtonProps) => (
  <StyledGoogleButton
    data-testid="google-button"
    disabled={!googleSSOUrl}
    onClick={() => {
      window.location.assign(googleSSOUrl!);
    }}
    disableRipple
    startIcon={<GoogleLogo />}
  >
    {label}
  </StyledGoogleButton>
);

export default GoogleButton;
